import StoredLayout from '../../layouts/StoredLayout'
import Changelog from './Changelog'
export default StoredLayout(Changelog)



// WEBPACK FOOTER //
// ./src/documentation/changelog/index.js